/**
 * Shared styling for a Radix `DropdownMenu.RadioItem`/`DropdownMenu.Item`, used by every toolbar menu
 * in this app. `theme/ThemeMenu.tsx` and `format/DateTimeFormatMenu.tsx` are mounted side by side in
 * `AppShell`'s header and had an identical copy of this class string each — `claude-kit/rules/
 * working-style.md`'s "favor the general, reusable solution once a pattern actually recurs" applies
 * as soon as a second menu needs the same look, which is exactly what happened here.
 */
export const DROPDOWN_MENU_ITEM_CLASS =
  'flex cursor-default select-none items-center gap-2 rounded-control px-2 py-2 text-sm ' +
  'outline-none data-[highlighted]:bg-accent-soft data-[highlighted]:text-accent-text';
